<div class="container">
    <ah-user-details readonly="true" [userInfo]="userInfo" (onSubmitDetails)="proceed($event)"></ah-user-details>
</div>
